export default __webpack_public_path__ + "static/media/1802.0bc9a926.png";